'use strict'
export default angular.module("mars.vet.dnareports.controllers.breedanalyzed",[]).controller('BreedsAnalyzedController',
    function($rootScope, $scope, $window, EntryService, EntryIDService, BreedListService, TranslationService, NavigationService,reportdata) {
      'ngInject'

        const resultString = reportdata.resultString;

        const specificEvidenceList = BreedListService.getBreedList(); // 'H', 'M', 'L', 'T' confidences - specific evidence
        const groupEvidenceList = resultString.next5; // mixed breed group - group evidence

        let evidenceList = [];

        angular.forEach(specificEvidenceList, function(count, breed) {
            if (breed != 'Mixed Breed Groups') {
                evidenceList.push(breed);
            }
        });

        if (specificEvidenceList['Mixed Breed Groups']) {
            angular.forEach(groupEvidenceList, function(value, key) {
                evidenceList.push(value);
            });
        }

        EntryService.getEntry(EntryIDService.getEntryID('Breeds Analyzed')).then(function(response) {
            const fields = response.fields;
            let description = response.fields.description;
            description = fields.description.replaceAll('[LINKREPLACE]', "<a class='leftnavigationlink' href='http://www.wisdompanel.com/breeds' target='_blank'>");
            $scope.descriptionArray = [];
            angular.forEach(description.split("\n"), function(value, key) {
                if (value != '') {
                    $scope.descriptionArray.push(value);
                }
            });
            //$scope.title = fields.title;
            $rootScope.pageTitle = fields.title;
            $scope.title = fields.title;
            $scope.subtitle = fields.subtitle;
            NavigationService.setNavigationUrls();
            $window.ga('send', 'pageview', {
                'page': $rootScope.pageTitle
            });
        });

//            $scope.breedGroups = resultString.breedGroups;

        EntryService.getEntry(EntryIDService.getEntryID('Breed Group Mappings')).then(function(response) {

            const fields = response.fields;
            let breedGroups = fields.breedGroupMapping;

 //           $scope.breedGroups = resultString.breedGroups;
 //           $scope.breedGroups = fields.breedGroupMapping;

            angular.forEach(breedGroups, function(breedGroup, breedGroupKey) {
                breedGroup['EvidenceBreed'] = [];

                angular.forEach(breedGroup['breedList'], function(breedList, breedListKey) {
                    angular.forEach(evidenceList, function(value, key) {
     //                   if (breedGroup['breedList'].indexOf(value) >= 0) {
                        if (breedList['breedname'] == value && breedList['enabled'] === true) {
                            breedGroup['SpecificEvidence'] = TranslationService.getTranslation('Specific Evidence Found');
                            breedGroup['EvidenceBreed'].push(value);
                        } else if (breedGroup['breedGroup'] == value) {
                            breedGroup['TraceEvidence'] = TranslationService.getTranslation('Trace Evidence Found');
                        }
                    });
                });
                if (breedGroup['SpecificEvidence'] === undefined && breedGroup['TraceEvidence'] === undefined) {
                    breedGroup['NoEvidence'] = TranslationService.getTranslation('No Evidence Found');
                }
            });
            $scope.breedGroups = breedGroups;
        }, function(error) {
            // promise rejected, could log the error with:
            // console.log('error', error);
        });

    }).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/breedsanalyzed.controller.js